import DialogActions from './DialogActions'

export { default as DialogActionButton } from './DialogActionButton'
export default DialogActions
